import { SET_SURAH_FILTER } from './actionTypes';

export const filterSurah = string => {
    return {
        type: SET_SURAH_FILTER,
        payload: string
    }
}
